import React, { useEffect, useState } from "react";
import { database, storage } from "../../../../firebase"; // Ensure this import is correct
import { ref, get, set, push } from "firebase/database"; // Import push
import { ref as storageRef, uploadBytes } from "firebase/storage";
import { toast } from "react-toastify";

const AdminRequestForm = ({ user }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [office, setOffice] = useState("");
  const [type, setType] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch Company Details
        const userRef = ref(database, `users/${user.uid}`);
        const userSnapshot = await get(userRef);

        if (userSnapshot.exists()) {
          const userData = userSnapshot.val(); // Extracting actual data
          const companyId = userData.companyId; // Access companyId correctly

          if (companyId) {
            const companyRef = ref(database, `companies/${companyId}`);
            const companySnapshot = await get(companyRef);

            if (companySnapshot.exists()) {
              setOffice(companySnapshot.val().branch || companySnapshot.val().companyName); // Extract address properly
            } else {
              console.log("No company found for this ID");
            }
          }
        } else {
          console.log("No user data found");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [user.uid]);
  const types = ["Email", "Prelisting kit", "Social media banner"];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const requestData = {
      companyId: user.companyId,
      title,
      description,
      office,
      type,
      userId: user.uid,
    };

    const requestsRef = ref(database, "requests");

    try {
      let attachmentUrl = null;
      if (attachment) {
        const attachmentRef = storageRef(
          storage,
          `attachments/${attachment.name}`
        );
        await uploadBytes(attachmentRef, attachment);
        attachmentUrl = `attachments/${attachment.name}`;
      }

      if (attachmentUrl) {
        requestData.attachment = attachmentUrl;
      }
      let userName = "";
      debugger;
      await set(push(requestsRef), requestData);
      if (requestData.userId) {
        const profileRef = ref(database, "profiles/" + requestData.userId);
        const profileSnapshot = await get(profileRef);
        if (profileSnapshot.exists()) {
          const userProfile = profileSnapshot.val();
          const middleNameSegment = userProfile.middleName || " ";
          userName = `${userProfile.firstName} " "${
            middleNameSegment ? middleNameSegment : ""
          }${userProfile.lastName}`;
        }
      }
      // Push the request data directly without generating a unique ID
      await sendEmailToSupport(requestData, userName);
      toast.success("Request send successfully");

      // Reset form fields
      setTitle("");
      setDescription("");
      setOffice("");
      setType("");
      setAttachment(null);
    } catch (error) {
      console.error("Error saving request:", error);
      toast.error("Failed to save request. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const sendEmailToSupport = async (requestData, userName) => {
    const emailData = {
      to: "support@multidynamic.com.au",
      subject: "New Request Submitted",
      text: `A new request has been submitted.\n\nDetails:\nTitle: ${requestData.title}\nDescription: ${requestData.description}\nOffice: ${requestData.office}\nType: ${requestData.type}\nUser: ${userName}`,
      html: `
            <div style="font-family: Arial, sans-serif; background-color: #f9f9f9; color: #333; padding: 20px; border-radius: 8px; max-width: 600px; margin: auto; border: 1px solid #ff6600;">
            <div style="background-color: #ff6600; color: white; padding: 15px; border-radius: 8px 8px 0 0; text-align: center;">
              <h1 style="margin: 0; font-size: 22px;">📩 New Request Submitted</h1>
            </div>
            <div style="padding: 20px; background: white; border-radius: 0 0 8px 8px;">
              <p style="font-size: 16px; margin: 10px 0;"><strong>🔹 Title:</strong> ${requestData.title}</p>
              <p style="font-size: 16px; margin: 10px 0;"><strong>📝 Description:</strong> ${requestData.description}</p>
              <p style="font-size: 16px; margin: 10px 0;"><strong>🏢 Office:</strong> ${requestData.office}</p>
              <p style="font-size: 16px; margin: 10px 0;"><strong>📂 Type:</strong> ${requestData.type}</p>
              <p style="font-size: 16px; margin: 10px 0;"><strong>👤 User:</strong> ${userName}</p>
              <p style="font-size: 16px; margin: 10px 0;">
                <strong>📎 Attachment:</strong> 
                <a href="${requestData.attachment}" style="color: #ff6600; text-decoration: none; font-weight: bold;" target="_blank">
                  View Attachment
                </a>
              </p>
            </div>
            <div style="background-color: #ff6600; color: white; padding: 10px; border-radius: 0 0 8px 8px; text-align: center;">
              <p style="margin: 0; font-size: 14px;">© 2024 Multidynamic. All rights reserved.</p>
            </div>
        </div>
      `,
    };

    try {
      const response = await fetch(
        "https://us-central1-md-digital-card.cloudfunctions.net/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(emailData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("Email sent to support successfully:", data);
      } else {
        console.error("Error sending email to support:", data.error);
      }
    } catch (error) {
      console.error("Error sending email to support:", error);
    }
  };

  return (
    <div className="flex justify-center items-center bg-white">
      <div className="bg-white rounded-lg w-full">
        <h2 className="text-2xl font-semibold text-center mb-4">
          New Support request
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="title">
              Title
            </label>
            <input
              type="text"
              id="title"
              className="border border-gray-300 rounded-md p-2 w-full"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-1"
              htmlFor="description"
            >
              Description
            </label>
            <textarea
              id="description"
              className="border border-gray-300 rounded-md p-2 w-full"
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="office">
              Office
            </label>
            <input
              type="text"
              id="office"
              className="border border-gray-300 rounded-md p-2 w-full"
              value={office}
              onChange={(e) => setOffice(e.target.value)}
              required
              disabled
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-1" htmlFor="type">
              Type
            </label>
            <select
              id="type"
              className="border border-gray-300 rounded-md p-2 w-full"
              value={type}
              onChange={(e) => setType(e.target.value)}
              required
            >
              <option value="" disabled>
                Select a type
              </option>
              {types.map((typeName) => (
                <option key={typeName} value={typeName}>
                  {typeName}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label
              className="block text-sm font-medium mb-1"
              htmlFor="attachment"
            >
              Attachment
            </label>
            <input
              type="file"
              id="attachment"
              accept="image/*"
              onChange={(e) => setAttachment(e.target.files[0])}
              className="border border-gray-300 rounded-md p-2 w-full"
            />
          </div>

          <button
            type="submit"
            className={`bg-blue-500 text-white rounded-md p-2 w-full hover:bg-blue-600 transition duration-200 ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit Request"}
          </button>
        </form>

        <div className="mt-6 text-center">
          <div className="bg-gray-200 p-4 rounded shadow-md">
            <p className="text-sm">Additional Information:</p>
            <p className="text-xs text-gray-600">
              Please make sure to fill out all fields before submitting.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminRequestForm;
